export const DEFAULT_ORDERS_PER_PAGE = 10;
export const STATUS_ORDERS_FACET_NAME = "status";
export const CUSTOMER_NAME_FACET_NAME = "customername";
